// Controls footer dropdowns on summary/summary_dws pages.
// Positions the dropdown menu and realigns on window scroll/resize and footer horizontal scroll.

const DROPDOWN_GAP = 8;
let activeDropdown = null; // { btn, menu }

function updateDropdownPosition() {
  if (!activeDropdown) {
    return;
  }

  const { btn, menu } = activeDropdown;
  const btnBox = btn.getBoundingClientRect();
  const menuWidth  = menu.offsetWidth;
  const menuHeight = menu.offsetHeight;

  const top = btnBox.top - menuHeight - DROPDOWN_GAP;
  const left = btnBox.right - menuWidth;

  menu.style.top  = `${top}px`;
  menu.style.left = `${left}px`;
}

export function handleFooterBtnClick(btn) {
  const id = btn.dataset.menu;
  const menu = document.getElementById(id);
  if (!menu) {
    return;
  }

  // Close currently open dropdown
  if (activeDropdown) {
    closeFooterDropdown();
  }

  btn.classList.add('active');
  menu.classList.add('active');
  activeDropdown = { btn, menu };

  updateDropdownPosition();
}

function closeFooterDropdown() {
  if (!activeDropdown) {
    return;
  }

  const { btn, menu } = activeDropdown;
  btn.classList.remove('active');
  menu.classList.remove('active');
  activeDropdown = null;
}

export function initFooterDropdownHandlers() {
  const footer = document.getElementById('fixed-footer');
  const footerInner = footer?.querySelector('#footer-content');

  if (!footerInner) {
    return;
  }

  // Reposition on window scroll/resize
  window.addEventListener('scroll', updateDropdownPosition);
  window.addEventListener('resize', updateDropdownPosition);

  // Reposition on footer horizontal scroll
  footerInner.addEventListener('scroll', updateDropdownPosition);

  // Close dropdown on click-away
  document.addEventListener('click', (e) => {
    if (!activeDropdown) {
      return;
    }

    const { btn, menu } = activeDropdown;
    if (!btn.contains(e.target) && !menu.contains(e.target)) {
      closeFooterDropdown();
    }
  });
}
